import {
  getStoryblokHeight,
  getStoryblokWidth,
} from "@/lib/storyblok/mediaFormatters";
import { TaggedImageStoryblokExtended } from "@/types/addtional-types";
import { getTaggedImageCards } from "../ProductGalleryWithTabs/getGalleryCards";
import styles from "./tagged-image.module.css";

import Image from "next/image";

type TaggedImageTag = {
  x: number;
  y: number;
};

import Skeleton from "@/components/atoms/Skeleton";
import { Suspense, useMemo } from "react";
import TagUI from "./ClientTag";

const Tag = ({
  tag,

  data,
}: {
  tag: TaggedImageTag;

  data: Awaited<ReturnType<typeof getTaggedImageCards>>[number];
}) => {
  const product = data;

  return (
    <div
      className={styles.tag}
      style={{
        top: `${tag.y}%`,
        left: `${tag.x}%`,
      }}
    >
      <Suspense fallback={<Skeleton height="50px" />}>
        <TagUI product={product} />
      </Suspense>
    </div>
  );
};

const TaggedImage = ({
  blok,
  data,
  sizes = "100vw",
}: {
  blok: TaggedImageStoryblokExtended;
  sizes: string;
  data: Awaited<ReturnType<typeof getTaggedImageCards>>;
}) => {
  const TaggedImageBlok = blok;

  const tags = useMemo(
    () =>
      TaggedImageBlok?.products?.products?.map((product, i) => {
        return {
          x: product.tag.x,
          y: product.tag.y,
          product: data?.[i],
        };
      }),
    [TaggedImageBlok.products.products, data]
  );

  if (!TaggedImageBlok.products.media) return null;

  const media = {
    file: TaggedImageBlok?.products?.media?.filename,
    alt: "",
    width: +(getStoryblokWidth(TaggedImageBlok?.products?.media) ?? 0),
    height: +(getStoryblokHeight(TaggedImageBlok?.products?.media) ?? 0),
    focus: undefined,
    _uid: TaggedImageBlok._uid,
  };

  if (!media.file) return null;

  return (
    <div className={styles.wrapper}>
      <Image
        src={media.file}
        alt={media.alt}
        fill={false}
        width={media.width}
        height={media.height}
        sizes={sizes}
        className={styles.image}
        style={{
          objectPosition: media.focus,
          aspectRatio: `${media.width}/${media.height}`,
        }}
      />

      {tags?.map((product, i) => {
        return (
          <Tag
            key={blok?._uid + i + product?.product?.core?.name}
            tag={product}
            data={product?.product}
          />
        );
      })}
    </div>
  );
};

export default TaggedImage;
